<template>
  <div class="waiting-list-view flex flex-col">
    <page-header
      :title="tr('Waiting list')"
      :info="tr('Here you can see the contents on the waiting list that require attention due to rules or advertising policy issues. Click on individual items for detailed information. You can approve or reject activities, or override AI decisions.')"
    />

    <div class="flex flex-col gap-4 py-5">
      <rule-waiting-list-content />
    </div>
  </div>
</template>

<script>
import PageHeader from '@/ui/components/PageHeader.vue';
import RuleWaitingListContent from '@/ui/components/RuleWaitingListContent.vue';

export default {
  name: 'WaitingListView',
  components: {
    RuleWaitingListContent,
    PageHeader,
  },
};
</script>
